<script setup lang="ts">
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import ImageResponsive from "@/components/ImageResponsive.vue";

const { t } = useI18n();
const router = useRouter();

const onBackClick = () => {
  if (window.history.state.back !== null) {
    return router.go(-1);
  }

  router.push({ name: "home" });
};
</script>

<template>
  <main class="container not-found-view">
    <AbcHeading size="lg" color="black">{{ t("not-found-view.heading") }}</AbcHeading>
    <p class="not-found-view__text">{{ t("not-found-view.text") }}</p>
    <TgButton @click="onBackClick()">{{ t("not-found-view.button-label") }}</TgButton>
    <ImageResponsive
      class="not-found-view__image"
      src="/assets/img/not-found/not-found@1x.png"
      presentational
    />
  </main>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.not-found-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;

  &__text {
    margin: 6px 0 30px;
    color: rgb(@theme-colors[@grey][base]);
    font-size: 1.125rem;
  }

  &__image {
    margin-top: 30px;
  }
}
</style>
